<template>
  <div class="color-dominance">

    <div class="colors">
      <div
        class="color-item"
        v-for="color, i in colors"
        v-on:click="setColorByIndex(i)"
        :key="i"
        :style="`
          background-color: ${color.hex};
          width: ${color.percentage * 100}%;
        `"
      ></div>
    </div>

    <div class="current-color" v-if="currentColor">
      <div class="color-palette" :style="`background-color: ${currentColor.hex}`">
      </div>
      <div class="color-text">
        {{currentColor.hex}}
        <span class="rgb" v-if="currentColorRGB">
          {{currentColorRGB}}
        </span>
      </div>
      <div class="color-percentage">
        {{parseInt(currentColor.percentage * 100)}}%
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    colors: Array
  },
  data() {
    return {
      currentIndex: -1
    }
  },
  methods: {
    setColorByIndex(i) {
      this.currentIndex = this.currentIndex === i ? -1 : i
    },
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

  },
  computed: {
    currentColor() {
      if (this.currentIndex > -1) {
        return this.colors[this.currentIndex]
      }
      return false
    },
    currentColorRGB() {
      if (!this.currentColor) {
        return false
      }
      let rgb = this.hexToRgb(this.currentColor.hex)
      if (rgb) {
        return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
      }
      return false
    }
  }
}

</script>

<style lang="scss" scoped>

.colors {
  display: flex;
  align-items: center;
  height: 90px;
  @media screen and (max-width: 940px) {
    height: 60px;
  }
}

.color-item {
  cursor: pointer;
  height: 100%;
}

.current-color {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.current-color .color-palette {
  width: 20px;
  height: 20px;
  border: 1px solid var(--gray-300);
  border-radius: 5px;
}
.current-color .color-text {
  color: var(--gray-700);
  font-size: var(--typ-body5);
  margin: 0 16px 0 8px;
}
.current-color .color-percentage {
  color: var(--gray-900);
  font-size: var(--typ-body2);
  font-weight: 700;
}

</style>